function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.27 13.53L3.87 16l-1.74-1 1.41-2.43a15.56 15.56 0 01-2.24-1.85l1.4-1.44A12.77 12.77 0 0012 13a12.77 12.77 0 009.3-3.72l1.4 1.44a15.56 15.56 0 01-2.24 1.81L21.87 15l-1.74 1-1.4-2.43A15 15 0 0113 15v3h-2v-3a15 15 0 01-5.73-1.47z"
});
function SvgEyeClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
}
export default SvgEyeClose;